import React, {Component} from "react"
import { withSiteData, Link, Head } from 'react-static'

class Footer extends Component {
  componentDidMount() {
 
  }

  render()
  {
    return (
      <footer>
        <div className="middleContainer clearfix">
          <div className="clearfix">
            <div className="leftBox contentContainer">
              <div className="linksBox">
                <a href="http://affiliate.worldsingles.com/index.cfm/auth/login" target="_blank">Partner Login</a>
                <a href="http://affiliate.worldsingles.com/" target="_blank">Become an Affiliate</a>
              </div>
            </div>
            <div className="rightBox contentContainer">
              <h3 className="helloThere">Hello there!</h3>
              <div className="linksBox clearfix">
                <div className="col1">
                  <div className="xSmallText">Contact us</div>
                  <a href="mailto:bizdev@worldsingles.com">New business</a>
                  <a href="/careers">Careers</a>
                  {/*<a href="mailto:hi@worldsingles.com">Say hi</a>*/}
                </div>
                <div className="col2">
                  <div className="xSmallText">Member support</div>
                  <a href="tel:+19497432535">(949) 743 2535</a>
                  <div className="xSmallText">Employment Verification</div>
                  <a href="tel:+19497432535">(949) 743 2535 ext. 7</a>
                  <div className="xSmallText">Employment Verification Fax</div>
                  <a href="">(949) 606 8551</a>
                </div>
              </div>
            </div>
          </div>

          <div className="bottomBox clearfix">
            <div className="leftBox contentContainer">
              <div className="xSmallText">Photo credits:</div>
              <div className="xSmallText"><a href="https://unsplash.com/">Unsplash</a> | Beautiful, free photos.
                Gifted by the world’s most generous community of photographers.
                  <br/>
              <a href="https://unsplash.com/@spacex">SpaceX</a>, <a href="https://unsplash.com/@thatsmrbio">Matthew Hamilton</a>, <a href="https://unsplash.com/@cristian_newman">Cristian Newman</a>, <a href="https://unsplash.com/@sgabriel">Sebastien Gabriel</a>
              </div>
            </div>
              <div className="rightBox contentContainer">
                <div className="copyright">
                  <div className="">
                    <span className="logoMark">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 65.682"
                          style={{width: '20px'}}>
                        <path style={{fill: '#fff'}}
                              d="M53.331,0L40.003,13.134L26.669,0L0,26.27l40.003,39.412L80,26.27L53.331,0z M40.003,52.544L13.333,26.27 l13.336-13.136L40.003,26.27l13.328-13.136L66.665,26.27L40.003,52.544z"/>
                      </svg>
                    </span>
                    <span>© World Singles Networks™, 2001-2022</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </footer>
    )
  }
}
export default withSiteData(Footer);



// WEBPACK FOOTER //
// /usr/src/app/src/containers/Footer.js